import { ContextAction } from '../types';
import type { ClaimDetailsAction, ClaimDetailsState } from './types';

export const userInitial = {};

export const claimDetailsReducer = (
  state: ClaimDetailsState | undefined,
  action: ClaimDetailsAction
): ClaimDetailsState | undefined => {
  switch (action.type) {
    case ContextAction.setClaimDetails:
      return { ...state, ...action.payload } as ClaimDetailsState;
    default:
      return state;
  }
};
